import a, { useEffect as h } from "react";
import { useDatePicker as F } from "./index39.mjs";
import { useLoadScrollableCalendar as L } from "./index40.mjs";
import { useAtom as o } from "jotai";
import "@amenitiz/design-system";
import { arrivalDateAtom as k, departureDateAtom as M } from "./index26.mjs";
import { Week as T } from "./index41.mjs";
import { MonthTitle as g } from "./index42.mjs";
import { Days as C } from "./index43.mjs";
import { Loader as N } from "./index44.mjs";
import t from "./index45.mjs";
import { scrollToFirstAvailableDay as R } from "./index46.mjs";
const G = ({
  setMaxDays: l,
  setMinDays: m,
  setWarning: s
}) => {
  const [c, n] = o(k), [d, p] = o(M), {
    loaderRef: f,
    isReachLimit: y,
    months: r,
    isWithinLimit: u,
    checkIfAvailable: v,
    getAvailabilityForDate: i,
    getFirstUnavailableDate: D,
    timeLimitCustomMessage: b
  } = L(), { scopedMap: E, setScopedMap: _ } = F(
    { setMaxDays: l, setMinDays: m },
    i
  );
  return h(() => {
    R(r);
  }, []), /* @__PURE__ */ a.createElement(
    "div",
    {
      "data-testid": "scrollable-calendar-container",
      className: t.scrollable_calendar_container
    },
    /* @__PURE__ */ a.createElement("div", { className: t.date_inputs }, /* @__PURE__ */ a.createElement(T, null)),
    /* @__PURE__ */ a.createElement("div", { "data-testid": "months-container", className: t.months_container }, r.map((e, A) => /* @__PURE__ */ a.createElement("div", { id: `month-index-${A}`, key: `${e.month}_${e.year}` }, /* @__PURE__ */ a.createElement(g, { month: e.month, year: e.year }), /* @__PURE__ */ a.createElement(
      C,
      {
        dateFrom: c,
        dateTo: d,
        setDateFrom: n,
        setDateTo: p,
        year: e.year,
        month: e.month,
        days: e.days,
        availabilities: e.availabilities,
        previousDays: e.previousDays,
        isWithinLimit: u,
        checkIfAvailable: v,
        getAvailabilityForDate: i,
        getFirstUnavailableDate: D,
        scopedMap: E,
        setScopedMap: _,
        setWarning: s,
        timeLimitCustomMessage: b
      }
    ))), y ? null : /* @__PURE__ */ a.createElement(N, { ref: f }))
  );
};
export {
  G as ScrollableCalendar
};
